export enum RESPONSE_TYPE {
    YES_NO = "YES_NO",
    PREFERENCE = "PREFERENCE",
    CHECK_LIST = "CHECK_LIST",
    BASIC_TEXT = "BASIC_TEXT",
}